import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PageHero from "@/components/feature/PageHero";
import { useContent } from "@/content/ContentProvider";
import Timetable from "./components/Timetable";
import ConsultCTA from "@/pages/home/components/ConsultCTA";

export default function Schedule() {
  const termSchedule = useContent("schedule.termSchedule");
  const vacationSchedule = useContent("schedule.vacationSchedule");
  const location = useLocation();
  const [tab, setTab] = useState<"term" | "vacation">("term");

  useEffect(() => {
    if (location.hash === "#vacation") setTab("vacation");
    else if (location.hash === "#term") setTab("term");
  }, [location.hash]);

  const data = tab === "term" ? termSchedule : vacationSchedule;

  return (
    <>
      <PageHero page="schedule" />

      <section className="bg-background-100 py-16 md:py-24">
        <div className="mx-auto max-w-content px-5 md:px-8">
          <div className="flex flex-col items-center">
            <div className="flex items-center gap-1 rounded-full border border-background-200 bg-background-50 p-1">
              <button
                type="button"
                onClick={() => setTab("term")}
                className={`whitespace-nowrap rounded-full px-6 py-2.5 text-sm font-bold transition-colors cursor-pointer ${
                  tab === "term"
                    ? "bg-primary-500 text-foreground-950"
                    : "text-foreground-700 hover:text-foreground-950"
                }`}
              >
                학기중
              </button>
              <button
                type="button"
                onClick={() => setTab("vacation")}
                className={`whitespace-nowrap rounded-full px-6 py-2.5 text-sm font-bold transition-colors cursor-pointer ${
                  tab === "vacation"
                    ? "bg-primary-500 text-foreground-950"
                    : "text-foreground-700 hover:text-foreground-950"
                }`}
              >
                방학중
              </button>
            </div>
            <p className="mt-4 max-w-md text-center text-sm text-foreground-700">
              {tab === "term"
                ? "정규 학기에는 학년·수준별 반이 요일별로 운영됩니다."
                : "방학에는 선행 특강과 복습 클리닉을 집중 운영합니다."}
            </p>
          </div>

          <Timetable schedule={data} />
        </div>
      </section>

      <ConsultCTA />
    </>
  );
}